import { Modal } from '../../base/_bootstrap';

document.addEventListener('DOMContentLoaded', () => {
   // if (document.querySelector('div.modal')) {
   //   if (localStorage.getItem('firstRun') === null) {
   //     new bootstrap.Modal(document.getElementById('primary')).show();
   //   }
   //   localStorage.setItem('firstRun', 'false');

   //   new bootstrap.Modal(document.getElementById('modal-primary')).show();
   // }

   document.querySelectorAll('a[href="#open-modal-form"]').forEach(link => {
      link.addEventListener('click', e => {
         e.preventDefault();
         new Modal(document.getElementById('modal-form')).show();
      });
   });
});
